import { render, staticRenderFns } from "./msgtypeVoice.vue?vue&type=template&id=04dafa90&scoped=true&"
import script from "./msgtypeVoice.vue?vue&type=script&lang=js&"
export * from "./msgtypeVoice.vue?vue&type=script&lang=js&"
import style0 from "./msgtypeVoice.vue?vue&type=style&index=0&id=04dafa90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dafa90",
  null
  
)

export default component.exports